// src/utils.js
// Handles XP, Level, Cooked recipes, and Pantry (ingredients/sauces)

const KEYS = {
  XP: "game-points",
  LEVEL: "game-level",
  COOKED: "recipes-cooked",
  INGREDIENTS: "pantry-ingredients",
  SAUCES: "pantry-sauces",
};

// ===== Basic localStorage helpers =====
const readJSON = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
};

const writeJSON = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {}
};

const readInt = (key, fallback = 0) => {
  try {
    const v = parseInt(localStorage.getItem(key), 10);
    return Number.isFinite(v) ? v : fallback;
  } catch {
    return fallback;
  }
};

const writeInt = (key, value) => {
  try {
    localStorage.setItem(key, String(value));
  } catch {}
};

// ===== XP / Level / Recipes =====
export const getGameStats = () => {
  const xp = readInt(KEYS.XP, 0);
  const level = Math.floor(xp / 100) + 1;
  const cooked = readJSON(KEYS.COOKED, []);
  return { xp, level, cooked };
};

export const awardXp = (points) => {
  const currentXp = readInt(KEYS.XP, 0);
  const newXp = currentXp + (Number(points) || 0);
  writeInt(KEYS.XP, newXp);
  writeInt(KEYS.LEVEL, Math.floor(newXp / 100) + 1);
  return newXp;
};

export const markRecipeCooked = ({ name, cuisine }) => {
  const cooked = readJSON(KEYS.COOKED, []);
  if (!cooked.some((r) => r.name === name)) {
    cooked.push({ name, cuisine, cookedAt: new Date().toISOString() });
    writeJSON(KEYS.COOKED, cooked);
  }
  return cooked;
};

// ===== Pantry Management =====
export const getPantry = () => ({
  ingredients: readJSON(KEYS.INGREDIENTS, []),
  sauces: readJSON(KEYS.SAUCES, []),
});

export const savePantry = ({ ingredients, sauces }) => {
  writeJSON(KEYS.INGREDIENTS, ingredients ?? []);
  writeJSON(KEYS.SAUCES, sauces ?? []);
};

export const STORAGE_KEYS = KEYS;
